export const SET_ACTIVE_TOOLTIP = 'Editor/Hotspots/SET_ACTIVE_TOOLTIP';
